import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "../../../axios";

export const topicApi = createAsyncThunk(
  "topic/fetchTopicsByCategory",
  async (params = {}, { rejectWithValue }) => {
    const {
      categoryId,
      limit = 10,
      skip = 0,
      individualTopic,
      topicId,
    } = params;

    // Handle individual topic fetching
    if (individualTopic && topicId) {
      try {
        const response = await axios.get(`/topics/${topicId}`);
        return { ...response.data, individualTopic: true };
      } catch (error) {
        if (error.response && error.response.data) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({
          success: false,
          message: "Failed to fetch topic",
        });
      }
    }

    // Handle category topics fetching
    if (!categoryId) {
      return rejectWithValue({
        success: false,
        message: "categoryId is required",
      });
    }
    try {
      const response = await axios.get(`/categories/${categoryId}/topics`, {
        params: { limit, skip },
      });
      return response.data; // { success, message, data: [...] }
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch topics",
      });
    }
  },
);

export const fetchTopicsForCategory = (categoryId, pageSize = 10, page = 1) => {
  return topicApi({ categoryId, limit: pageSize, skip: (page - 1) * pageSize });
};

export const nextPage = () => (dispatch, getState) => {
  const state = getState().activeTopics;
  if (state.pagination.hasMore) {
    const nextPageNum = state.pagination.currentPage + 1;
    dispatch(
      fetchTopicsForCategory(
        state.categoryId,
        state.pagination.pageSize,
        nextPageNum,
      ),
    );
  }
};

export const prevPage = () => (dispatch, getState) => {
  const state = getState().activeTopics;
  if (state.pagination.currentPage > 1) {
    const prevPageNum = state.pagination.currentPage - 1;
    dispatch(
      fetchTopicsForCategory(
        state.categoryId,
        state.pagination.pageSize,
        prevPageNum,
      ),
    );
  }
};

export const goToPage = (page) => (dispatch, getState) => {
  const state = getState().activeTopics;
  if (page >= 1 && page <= state.pagination.totalPages) {
    dispatch(
      fetchTopicsForCategory(state.categoryId, state.pagination.pageSize, page),
    );
  }
};

export const getTopicById = (topicId) =>
  topicApi({ individualTopic: true, topicId });

export const coachesByTopicApi = createAsyncThunk(
  "coaches/fetchCoachesByTopic",
  async (params = {}, { rejectWithValue }) => {
    const { topicId, limit = 10, skip = 0 } = params;
    if (!topicId) {
      return rejectWithValue({
        success: false,
        message: "topicId is required",
      });
    }
    try {
      const response = await axios.get(`/coaches/topic/${topicId}`, {
        params: { limit, skip },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch coaches by topic",
      });
    }
  },
);

export const loadMoreCoaches = (topicId, skip) => {
  return coachesByTopicApi({ topicId, limit: 10, skip });
};
